export default "__VITE_PUBLIC_ASSET__9897aec2__"